(function() {
  // ============ CONFIGURATION ============
  var QUALIFYING_HANDLES = [
    '1436-jon-boat-aluminum-build-kit',
    'boat-build-aluminum-kit',
    'build-a-deck-kit-frame-hatches-combo',
    '14ft-deep-v-aluminum-boat-kit',
    '1648-jon-boat-weekend-warrior-kits',
    'gen-x-boat-in-a-box-kit-1232-jon-boat',
    'gen-x-14-15-jon-boat-kit',
    'tightlinetv-1436'
  ];

  // Variant ID of the free gift (TBN Core Membership)
  var GIFT_VARIANT_ID = 44180186202247;
  // ========================================

  var CART_API = '/cart.js';
  var ADD_API = '/cart/add.js';
  var CHANGE_API = '/cart/change.js';

  var isUpdating = false;

  function getCart() {
    return fetch(CART_API, { credentials: 'same-origin' }).then(function(res) {
      return res.json();
    });
  }

  function addGift() {
    return fetch(ADD_API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
    });
  }

  function removeGift(lineIndex) {
    return fetch(CHANGE_API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    });
  }

  function hasQualifyingProduct(cart) {
    return cart.items.some(function(item) {
      return QUALIFYING_HANDLES.indexOf(item.handle) !== -1;
    });
  }

  function findGiftLineIndex(cart) {
    return cart.items.findIndex(function(item) {
      return item.variant_id === GIFT_VARIANT_ID;
    });
  }

  function syncGift(callback) {
    if (isUpdating) return;
    isUpdating = true;

    getCart().then(function(cart) {
      var qualifies = hasQualifyingProduct(cart);
      var giftIndex = findGiftLineIndex(cart);
      var hasGift = giftIndex !== -1;

      if (qualifies && !hasGift) {
        return addGift().then(function() {
          reloadCartUI();
          if (callback) callback();
        });
      } else if (!qualifies && hasGift) {
        return removeGift(giftIndex + 1).then(function() {
          reloadCartUI();
          if (callback) callback();
        });
      } else {
        if (callback) callback();
      }
    }).catch(function(e) {
      console.error('[Free Gift]', e);
      if (callback) callback();
    }).finally(function() {
      isUpdating = false;
    });
  }

  function reloadCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // If your theme uses a cart drawer section, uncomment and adjust:
    //
    // fetch('/?section_id=cart-drawer')
    //   .then(function(r) { return r.text(); })
    //   .then(function(html) {
    //     var parser = new DOMParser();
    //     var doc = parser.parseFromString(html, 'text/html');
    //     var newCart = doc.querySelector('#cart-drawer');
    //     if (newCart) {
    //       document.querySelector('#cart-drawer').innerHTML = newCart.innerHTML;
    //     }
    //   });
  }

  // --- Intercept fetch to detect cart changes ---
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    // Intercept checkout fetches — sync gift before allowing through
    if (url.includes('/wallets/checkouts') || url.includes('/checkout')) {
      return new Promise(function(resolve) {
        syncGift(function() {
          resolve(originalFetch.apply(window, args));
        });
      });
    }

    var result = originalFetch.apply(this, args);

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      result.then(function() {
        if (!url.includes(String(GIFT_VARIANT_ID))) {
          setTimeout(syncGift, 300);
        }
      });
    }
    return result;
  };

  // --- Intercept XMLHttpRequest for older themes ---
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origXHROpen.apply(this, arguments);
  };

  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    var self = this;
    this.addEventListener('load', function() {
      if (
        self._url &&
        (self._url.includes('/cart/add') ||
         self._url.includes('/cart/change') ||
         self._url.includes('/cart/update'))
      ) {
        if (!self._url.includes(String(GIFT_VARIANT_ID))) {
          setTimeout(syncGift, 300);
        }
      }
    });
    return origXHRSend.apply(this, arguments);
  };

  // --- Intercept direct-to-checkout (Buy Now / form submissions) ---
  document.addEventListener('submit', function(e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';

    if (action.includes('/checkout') || action.includes('/cart')) {
      e.preventDefault();
      syncGift(function() {
        form.submit();
      });
    }
  }, true);

  // Intercept clicks on direct checkout links
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/checkout"]');
    if (link) {
      e.preventDefault();
      var href = link.href;
      syncGift(function() {
        window.location.href = href;
      });
    }
  }, true);

  // Run on page load
  syncGift();
})();